import { styled, mixins, theme } from 'ui/theme';

const TextBase = styled('div')`
  ${mixins.baseFont};

  &[data-text-align='center'] {
    text-align: center;
  }
  &[data-text-align='left'] {
    text-align: left;
  }
  &[data-text-align='right'] {
    text-align: right;
  }

  &[data-margin-bottom='sp-3'] {
    margin-bottom: ${theme.space[3]};
  }

  &[data-margin-bottom='sp-4'] {
    margin-bottom: ${theme.space[4]};
  }

  > span {
    &[data-overline='true'] {
      ${mixins.overline};
    }
    &[data-variant='body-large-standard'] {
      ${mixins.bodyLargeStandard};
    }
    &[data-variant='body-large-short'] {
      ${mixins.bodyLargeShort}
    }
    &[data-variant='body-medium-standard'] {
      ${mixins.bodyMediumStandard}
    }
    &[data-variant='body-medium-short'] {
      ${mixins.bodyMediumShort}
    }
    &[data-variant='auxiliar-small'] {
      ${mixins.auxiliarSmall}
    }
    &[data-variant='auxiliar-mini'] {
      ${mixins.auxiliarMini}
    }
    // Colors
    &[data-color='medium-light-1'] {
      color: ${theme.colors.build.mediumLight1};
    }
  }
`;

export default TextBase;
